// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function RedditLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M31.5 13a4.5 4.5 0 0 0-7.175-3.616 18.194 18.194 0 0 0-6.567-1.806l.475-2.852 1.958.327a3 3 0 1 0 .494-2.96L17.25 1.52a1.5 1.5 0 0 0-1.73 1.23l-.797 4.789c-2.538.164-4.973.799-7.048 1.845a4.5 4.5 0 0 0-5.94 6.71A7.858 7.858 0 0 0 1.5 18c0 2.911 1.581 5.609 4.454 7.598C8.658 27.468 12.225 28.5 16 28.5c3.775 0 7.343-1.031 10.046-2.902C28.92 23.608 30.5 20.91 30.5 18c0-.643-.079-1.283-.235-1.906A4.52 4.52 0 0 0 31.5 13Zm-3.739 1.293a1.5 1.5 0 0 0-.625 1.875c.237.582.36 1.204.364 1.832 0 1.898-1.125 3.719-3.161 5.131C22.13 24.66 19.17 25.5 16 25.5c-3.17 0-6.125-.841-8.339-2.369C5.625 21.72 4.5 19.898 4.5 18a4.967 4.967 0 0 1 .355-1.83 1.5 1.5 0 0 0-.616-1.875 1.5 1.5 0 1 1 1.975-2.17 1.5 1.5 0 0 0 1.992.398l.028-.017C10.367 11.21 13.125 10.5 16 10.5s5.625.711 7.761 2l.028.016a1.5 1.5 0 0 0 1.997-.391A1.483 1.483 0 0 1 27 11.5a1.5 1.5 0 0 1 .761 2.793ZM11 18.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM23.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-2.565 5.065a1.5 1.5 0 0 1-1 1.875c-2.57.754-5.304.754-7.875 0a1.503 1.503 0 0 1 .875-2.875c2 .58 4.124.58 6.125 0a1.5 1.5 0 0 1 1.875 1Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
